import api from 'api/instance';
import { FetchQueryType, FetchResponse } from 'types/common';

import { Customer } from 'types/user';

const URL = `${process.env.REACT_APP_API_URL}`;

type CustomersResponse = {
  message: string;
  items: Customer[];
};

export const fetchCustomers = async (washHub?: string, limit?: number) => {
  const { data } = await api.get<CustomersResponse>(
    `${URL}/user/customers/list`,
    {
      params: {
        washHub,
        limit,
      },
    },
  );

  return data?.items;
};

export const fetchPaginatedCustomers = async (params: FetchQueryType) => {
  const { data } = await api.get<FetchResponse<Customer>>(
    `${URL}/user/customers/list`,
    {
      params,
    },
  );

  return data;
};

type CreateCustomerPayload = {
  companyName: string;
  type: string;
  washHub: string;
  washHubCode: string;
  site: string;
  siteCode: string;
  billingContact: string;
  collectionPoint: string;
  collectionPointCode: string;
};

export const createCustomer = async (payload: CreateCustomerPayload) => {
  const { data } = await api.post(`${URL}/user/customer/create`, payload);

  return data;
};

export const deleteCustomers = async (ids: string[]) => {
  const { data } = await api.delete(`${URL}/user/remove-many`, {
    data: { ids },
  });

  return data;
};

export const updateCustomer = async (
  payload: CreateCustomerPayload & { _id: string },
) => {
  const { _id, ..._payload } = payload;

  const { data } = await api.patch(`${URL}/user/customers/${_id}`, _payload);

  return data;
};
